var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
var DEFAULT_VALUE = {
  subscribers: [],
  toggleSubscriber: /* @__PURE__ */ __name(function toggleSubscriber() {
  }, "toggleSubscriber")
};
var ScrollMarkerContext = /* @__PURE__ */ React.createContext(DEFAULT_VALUE);
export {
  DEFAULT_VALUE,
  ScrollMarkerContext
};
